<template>
  <div class="test-item">
    <div class="test-item-tigan">
      <div class="test-item-tigan-html" v-html="data.questionBody"></div>
      <div v-if="showSound==true&&data.questionSound">
        <span class="icon iconfont iconyinpin hand" @click=playSound(data.questionSound)>
        </span>
      </div>
      <slot name="toolbar"></slot>
    </div>
    <audio :src="data.questionSound" :id="'test'+data.questionId"></audio>
    <div class="test-item-questionOpt" v-for="item in data.questionOpt"><label
        v-if="data.questionAnswer==item.option"><input type="radio" :name="'radio-item'+data.questionId" disabled="disabled" checked/>
      <span>{{item.option}}</span></label><label
        v-else><input type="radio" :name="'radio-item'+data.questionId"
                      disabled="disabled"/><span>{{item.option}}</span></label></div>
    <div class="test-item-daan" v-if="showAnswer==true">
      <el-tag size="small" type="success " style="margin-right:1em">答案</el-tag>
      {{data.questionAnswer}}
    </div>
    <div class="test-item-jiexi" v-if="showResolve==true">
      <el-tag size="small" type="success " style="margin-right:1em">解析</el-tag>
      <p style="margin-left:1em" v-html="data.questionResolve"></p></div>
    <div class="test-item-createtime" v-if="showTimer==true">创建于：{{data.createTimeStr}}</div>
  </div>
</template>

<script>
  export default {
    name: 'TestItemPickWrong',
    props: {
      data: {
        required: true
      },
      showAnswer: {
        type: Boolean,
        default: true
      },
      showStudentAnswer: {
        type: Boolean,
        default: true
      },
      showResolve: {
        type: Boolean,
        default: true
      },
      showTimer: {
        type: Boolean,
        default: true
      },
      showSound: {
        type: Boolean,
        default: true
      },
      testIndex: {
        type: Number,
        default: 1
      },
      testPoint: {
        type: Number,
        default: 0
      }
    },
    // data:function(){
    // 	console.log(this.data)
    // 	this.init();
    // 	return this.data;
    // },
    methods: {
      init() {
        var questionOpt;
        //console.log(typeof this.data.questionOpt)
        if (typeof this.data.questionOpt === 'object') {
          // questionOpt = JSON.parse(decodeURIComponent(this.data.questionOpt))
          questionOpt = this.data.questionOpt;
        } else if (typeof this.data.questionOpt === 'string') {
          //console.log(JSON.parse());
          try {
            questionOpt = JSON.parse(decodeURIComponent(this.data.questionOpt));
          } catch (e) {
            //console.log(1111)
          }

          //questionOpt = JSON.parse(questionOpt) ;
          //questionOpt = JSON.parse(decodeURIComponent(this.data.questionOpt)) ;
        }
        if (this.data.questionSound == '') {
          this.data.questionSound = null;
        }
        this.data.questionOpt = questionOpt;
        if (this.data.questionAnswer) {
          this.data.questionAnswer = decodeURIComponent(this.data.questionAnswer);
        }

        this.data.questionResolve = decodeURIComponent(this.data.questionResolve);
        if (this.data.questionBody) {
          var questionBody = decodeURIComponent(this.data.questionBody);
          var index = this.testIndex <= 0 ? '' : this.testIndex + '. ';
          var point = this.testPoint <= 0 ? '' : '（' + this.testPoint + '分）';
          this.data.questionBody = index + point + questionBody;
        }

      },
      playSound(val) {
        var audio = document.getElementsByTagName('audio');
        for (var i = 0; i < audio.length; i++) {
          audio[i].pause();
        }
        let player = document.querySelector('#test' + this.data.questionId);
        if (player.paused) {
          player.play();
        } else {
          player.pause();
        }
      }
    },
    created() {
      this.init();
    }

  };
</script>

<style scoped>
  .test-item-daan {
    margin-top: 10px;
    border-top:none ;
  }
  
  
  .content-bg{
    background-color: lightgrey;
  }
  .box{
    background-color: white;
    
  }
  header{
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    margin: 20px;
    height: 50px;
  }
  .h1{
    font-size: 38px;
    padding: 30px;
  }
  .h1-title{
    padding: 30px;
  }
  .h1-right{
    padding: 30px;
    font-size: 38px;
  }
  .test-page-header{
    margin: 20px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    
  }
  .test-page-content{
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    margin: 20px;
    
  }
  .test-page-content-panel{
    flex-grow: 1;
    padding: 20px;
  }
  .test-page-bar{
    width:360px;
    min-width:360px;
    margin-left: 20px;
    min-height: 600px;
  }
  .test-toolbar-panel{
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    flex-direction: column;
    background-color:white;
    padding: 20px;
    width:320px;
    border-bottom: 1px solid lightgrey;
  }
  .test-toolbar-panel-content{
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    padding: 10px;
    
  }
  .test-mini-item{
    display: flex;
    display: -webkit-flex;
    width: 30px;
    height:30px;
    color: white;
    font-weight: bolder;
    border-radius: 50%;
    margin-right: 10px;
    background: #AEADAD;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-bottom: 10px;
  }
  /* .test-toolbar-panel:first-child{
    padding: 10px;
    border-bottom: 1px solid lightgrey;
  } */
  .total-point{
    padding: 30px;
    font-size: 38px;
    color:red;
    
  }
  .test-toolbar-bar{
    display: flex;
    display: -webkit-flex;
    align-items: baseline;
  }
  .test-mini-panel-title{
    display: flex;
    display: -webkit-flex;
    justify-content:space-between;
    padding: 10px;
    width:300px;
  }
  .test-mini-panel{
    display: flex;
    display: -webkit-flex;
    justify-content:flex-start;
    flex-wrap:wrap;
    
    padding: 10px;
  }
  .test-toolbar-time-title{
    color:grey;
  }
  .test-toolbar-time{
    padding: 10px;
    font-size: 30px;
    color:lightslategray;
  }
  .contact{
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    color:lightslategray ;
  }
  .phone-box{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #58B3E6;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    margin:10px ;
  }
  .test-content-heder{
    border-bottom: 1px dotted lightgray;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }
  .big-test-title{
    font-size: 18px;
    color: dimgrey;
    margin-bottom: 10px;;
  }
  .test-jiexi div{
    padding: 5px;
  }
  .floatfixed{
    position:absolute;
    z-index:40;
  }
  .floatfixed2{
    position:absolute;
    z-index:20;
    overflow:auto;
  }
  .rightscoll{
    overflow:auto;
  }
</style>
